export default __webpack_public_path__ + "static/media/cosmic_screenshot.20d85848.png";